import Vue from 'vue'
import VueRouter from 'vue-router'
import Vuex from 'vuex'
import App from './App.vue'

Vue.config.devtools = true

Vue.use(VueRouter);
Vue.use(Vuex);

import Categories from './components/categories.vue'
import Category from './components/category.vue'
import Meal from './components/meal.vue'
import Cart from './components/cart.vue'
import CartHeader from './components/cart-header.vue'

Vue.component('cart-header', CartHeader)

const routes = [
  { path: '/', component: Categories, name: 'categories' },
  { path: '/menu/:id', component: Category, name: 'category' },
  { path: '/menu/:id/:pid', component: Meal, name: 'meal' },
  { path: '/calc', component: Cart, name: 'cart' },
]

const router = new VueRouter({
  routes // short for `routes: routes`
})

const store = new Vuex.Store({
  state: {
    menu: [],
    language: {},
    cart: []
  },
  mutations: {
    update (state, menu) {
      state.menu = menu
    },
    update_cart(state, cart){
      state.cart = cart
    },
    language (state, translation){
      state.language = translation
    },
    add_to_cart (state, item){
      state.cart.push(item)
    },
    remove_from_cart (state, item){
      state.cart.splice(item, 1)
    },
    update_include(state, data){
      Vue.set(state.cart[data.index], 'include', data.value)
    }
  }
})

Vue.config.productionTip = false

new Vue({
  router: router,
  store: store,
  render: h => h(App),
}).$mount('#app')
